import { createSelector } from '@ngrx/store';

import { getTrustTaxInfo } from '../../reducers';

export const selectTrustTaxInfoState = createSelector(getTrustTaxInfo, (state) => state);
